<template>
    <svg>
        <title v-if="title">{{ title }}</title>
        <use :href="'#' + name" v-bind="{ 'xlink:href': '#' + name }"></use>
    </svg>
</template>

<script>
    export default {
        name: "iconSymbol",
        props: ["name", "title"],
    };
</script>

<style></style>
